import { useEffect, useState, useCallback } from "react";
import { TRANSLATIONS, getT } from "../i18n/marketing";

const KEY = "cbt:marketing_lang";

const detectDefault = () => {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored && TRANSLATIONS[stored]) return stored;
    const nav = (navigator?.language || "").toLowerCase();
    if (nav.startsWith("de")) return "de";
    if (nav.startsWith("en")) return "en";
    return "no";
  } catch {
    return "no";
  }
};

export function useMarketingLang() {
  const [lang, setLangState] = useState(detectDefault);

  const setLang = useCallback((next) => {
    if (!TRANSLATIONS[next]) return;
    try { localStorage.setItem(KEY, next); } catch { /* noop */ }
    setLangState(next);
    // update html[lang] for accessibility / SEO
    try { document.documentElement.lang = next; } catch { /* noop */ }
  }, []);

  useEffect(() => {
    try { document.documentElement.lang = lang; } catch { /* noop */ }
  }, [lang]);

  return { lang, setLang, t: getT(lang) };
}
